<template>
  <el-dialog title="地址管理" :visible.sync="formVisible" :close-on-click-modal="false" width="900px" v-if="formVisible">
    <div class="address-manage">
      <el-button type="primary" size="small" icon="el-icon-plus" @click="handleAdd">添加地址</el-button>
      <el-table v-loading="listLoading" :data="list" style="margin-top: 15px;">
        <el-table-column label="收货人" prop="customerName" align="center" />
        <el-table-column label="收货人手机号" prop="customerPhone" align="center" width="140" />
        <el-table-column label="收货地址" align="center">
          <template slot-scope="{row}">
            {{ row.province }}{{ row.city }}{{ row.district }}{{ row.detailedAddress }}
          </template>
        </el-table-column>
        <el-table-column label="是否默认地址" align="center">
          <template slot-scope="{row}">
            {{ row.isDefault==1?"是":"否" }}
          </template>
        </el-table-column>
        <el-table-column label="操作时间" prop="createdTime" align="center" width="180" />
        <el-table-column label="操作" align="center" width="120">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleEdit(row)">编辑</el-button>
            <el-button type="text" style="color: #F56C6C;" @click="handleDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total > 0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </div>

    <!-- 添加/编辑地址弹窗 -->
    <el-dialog
      :title="editForm.id ? '编辑地址' : '添加地址'"
      :visible.sync="editVisible"
      width="500px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="editForm" :model="editForm" :rules="editRules" label-width="100px" size="small">
        <el-form-item label="收货人" prop="customerName">
          <el-input v-model="editForm.customerName" placeholder="请输入收货人" />
        </el-form-item>
        <el-form-item label="手机号" prop="customerPhone">
          <el-input v-model="editForm.customerPhone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="收货地址" prop="regionCode">
          <el-cascader
            v-model="editForm.regionCode"
            :options="addressOptions"
            :props="cascaderProps"
            placeholder="请选择省市区"
            clearable
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="详细地址" prop="detailedAddress">
          <el-input v-model="editForm.detailedAddress" type="textarea" :rows="2" placeholder="请输入详细地址" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确认</el-button>
      </div>
    </el-dialog>
  </el-dialog>
</template>

<script>
import customerAddressApi from '@/api/client/customerAddress'
import sysAddrApi from '@/api/sys/sysAddr'
import Pagination from '@/components/Pagination'

export default {
  components: { Pagination },
  data() {
    return {
      formVisible: false,
      listLoading: false,
      list: [],
      total: 0,
      query: {
        pageNo: 1,
        pageSize: 10,
        userId: null
      },
      currentRow: null,
      // 编辑弹窗
      editVisible: false,
      editForm: {
        id: null,
        userId: null,
        customerName: '',
        customerPhone: '',
        regionCode: [],
        detailedAddress: '',
        province: '',
        provinceCode: '',
        city: '',
        cityCode: '',
        district: '',
        districtCode: '',
        country: '',
        isDefault: 0
      },
      editRules: {
        customerName: [{ required: true, message: '请输入收货人', trigger: 'blur' }],
        customerPhone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
        ],
        regionCode: [{ required: true, message: '请选择省市区', trigger: 'change' }],
        detailedAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }]
      },
      addressOptions: [],
      cascaderProps: {
        label: 'regionName',
        value: 'regionCode',
        children: 'child'
      }
    }
  },
  created() {
    this.getAddressOptions()
  },
  methods: {
    handleUpdate(row) {
      this.currentRow = row
      this.query.userId = row.customerUserPO.id
      this.formVisible = true
      this.doQueryList({ pageNo: 1 })
    },
    doQueryList({ pageNo, pageSize }) {
      if (pageNo) this.query.pageNo = pageNo
      if (pageSize) this.query.pageSize = pageSize
      this.listLoading = true
      customerAddressApi.fetchList(this.query).then(res => {
        this.list = res.data.list || []
        this.total = res.data.total || 0
      }).finally(() => {
        this.listLoading = false
      })
    },
    getAddressOptions() {
      sysAddrApi.getAddressTreeList().then(({ data }) => {
        this.addressOptions = this.formatCascaderData(data)
      })
    },
    formatCascaderData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].child && data[i].child.length < 1) {
          data[i].child = undefined
        } else if (data[i].child) {
          this.formatCascaderData(data[i].child)
        }
      }
      return data
    },
    handleAdd() {
      this.editForm = {
        id: null,
        userId: this.query.userId,
        customerName: '',
        customerPhone: '',
        regionCode: [],
        detailedAddress: '',
        province: '',
        provinceCode: '',
        city: '',
        cityCode: '',
        district: '',
        districtCode: '',
        country: '',
        isDefault: 0
      }
      this.editVisible = true
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate()
      })
    },
    handleEdit(row) {
      this.editForm = {
        id: row.id,
        userId: row.userId,
        customerName: row.customerName,
        customerPhone: row.customerPhone,
        regionCode: [row.provinceCode, row.cityCode, row.districtCode].filter(Boolean),
        detailedAddress: row.detailedAddress,
        province: row.province,
        provinceCode: row.provinceCode,
        city: row.city,
        cityCode: row.cityCode,
        district: row.district,
        districtCode: row.districtCode,
        country: row.country || '',
        isDefault: row.isDefault || 0,
        country: "中国大陆"
      }
      this.editVisible = true
      this.$nextTick(() => {
        this.$refs.editForm && this.$refs.editForm.clearValidate()
      })
    },
    handleDelete(row) {
      this.$confirm('确定删除该地址吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        customerAddressApi.deleteById(row.id).then(() => {
          this.$message.success('删除成功')
          this.doQueryList({ pageNo: 1 })
        })
      })
    },
    submitForm() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          // 解析省市区
          const codes = this.editForm.regionCode || []
          const names = this.getRegionNames(codes)
          const params = {
            userId: this.editForm.userId,
            customerName: this.editForm.customerName,
            customerPhone: this.editForm.customerPhone,
            detailedAddress: this.editForm.detailedAddress,
            provinceCode: codes[0] || '',
            province: names[0] || '',
            cityCode: codes[1] || '',
            city: names[1] || '',
            districtCode: codes[2] || '',
            district: names[2] || '',
            country: this.editForm.country || '',
            isDefault: this.editForm.isDefault || 0,
            country: "中国大陆"
          }
          
          // 编辑时添加id
          if (this.editForm.id) {
            params.id = this.editForm.id
          }

          const api = this.editForm.id ? customerAddressApi.update(params) : customerAddressApi.create(params)
          api.then(() => {
            this.$message.success('操作成功')
            this.editVisible = false
            this.doQueryList({ pageNo: 1 })
          })
        }
      })
    },
    getRegionNames(codes) {
      const names = []
      let options = this.addressOptions
      for (let i = 0; i < codes.length; i++) {
        const found = options.find(item => item.regionCode === codes[i])
        if (found) {
          names.push(found.regionName)
          options = found.child || []
        }
      }
      return names
    }
  }
}
</script>

<style lang="scss" scoped>
.address-manage {
  min-height: 300px;
}
</style>

